import fetch from './lib/fetch'

export async function getOnboardingStatus(rechargeId: string) {
  return (await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/onboarding-status`
  )) as { hasSetDate: boolean }
}
